module.exports = __webpack_public_path__ + "images/interview-Microsoft-2.svg";